import React, { useRef, useState,useEffect } from "react";
import TextInput from "../Components/TextInput/TextInput";
import styles from "./bannerForm.module.css";
import { AiOutlineClose } from "react-icons/ai";
import { showSnackbarAction } from "../Redux/actions";
import { themeColors } from "../Components/theme";
import Dropdown from "../Components/DropDown/Dropdown";
import Label from "../Components/Label";
import { connect, useDispatch } from "react-redux";
import {uploadFileToS3,createBanner,updateBanner} from "../Values/utils"
import moment from "moment";
import { useLocation } from 'react-router-dom';
import {fetchDbConstants} from "../Services/marketingAutomation"

const Requirement = ["navBanner","popUp","pageBanner","footerPopup","contactSideView","contactMidView"];
const bannerContentType = ["HTML", "image"];
// const pageArr=["Conatct page","Task Page","callLogs Page","Listing Page","Analytics Page"];

// const mapObj:any={"Conatct page":"/contacts","Task Page":"/tasks","callLogs Page":"/callLogs","Listing Page":"/projects","Analytics Page":"/analytics"}


const Addbanner = ({
  history,
  user,
  theme,
}: any) => {
  const location = useLocation();
  const state:any = location.state ;

  const isEdit:Boolean=state?.edit || false
  const editData:any=state?.data || {}

  console.log("state on edit ",editData)
  const dispatcher = useDispatch();

  const startdateRef: any = useRef();

  const endDateRaf:any= useRef();

  const getToday = () => {
    const today = new Date();
    return today.toISOString().split('T')[0]; // YYYY-MM-DD
  };
  
  const defaultStartDate = getToday();
  const defaultEndDate = getToday();



  const [mapObj,setMapObj]=useState<any>({})
  const [pageArr,setPageArr]=useState<any>([])
  const [tagArr,setTagArr]=useState<any>({})

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data: any = await fetchDbConstants(["BANNER_DROPDOWN","BANNER_PAGE_WISE_CONSTANTS"]);
        if (data && data.length >0) {
          
         data.forEach((val:any)=>{
           if(val?.type==="BANNER_DROPDOWN" && val?.data){
             setMapObj(val.data)

          console.log("MAP",val.data)

          const modifiedArr=Object.keys(val.data)
          setPageArr(modifiedArr)
           } else if (val?.type==="BANNER_PAGE_WISE_CONSTANTS" && val?.data){
               setTagArr(val.data)
           }
         })
        }
      } catch (error: any) {
        // console.log("Error fetching ROI dates:", error.message);
      }
    };

    fetchData();
  }, []);
  
  

  const [bannerType, setBannerType] = useState<any>("");
  const [bannerStatus,setBannerStatus]=useState<any>({
    label: "DRAFT",
    value:"DRAFT" ,
  });
  const [bannerContentTypeSelected, setBannerContentTypeSelected] =  useState<any>({
        label: "image",
        value: "image",
      });
  const [page,setPage]=useState<any>({
    label:"",
    value:""
  })
  const [htmlContent, setHtmlContent] = useState<string>("");
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [day,setDay]=useState<any>([{
    label: "All",
    value: "All",
  }])
  const [frequency,setFrequency]=useState<any>({
    label: "All",
    value: "All",
  })

  const [autoLogin,setAutoLogin]=useState<any>({
    label:"false",
    value:"false"
  })

  const [impressionGA,setImpressionGA]=useState("")
  const [ctaGA,setCtaGA]=useState("")
  const [additionalDropdown, setAdditionalDropdown] = useState<any>([]);

  const [landingUrl,setLandingUrl]=useState<string>("")
  const maxDate = new Date().toISOString().split("T")[0];
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [name,setName]=useState<any>("")
  const [tagOption,setTagOption]=useState<any>([])

  const containerStyles = {
    backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };

  const cardContainerStyles = {
    backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };

  const selectInputContainerStyles = { width: "100%", marginRight: "0px" };
  function formatDateForInput(dateStr:any) {
    const [day, month, year] = dateStr.split('/');
    return `${year}-${month}-${day}`;
  }

  useEffect(() => {
    if (isEdit && editData) {
       const bannerTypeData=[]
       const tagArrrrrr:any=[]

       if(editData.navBanner){
          bannerTypeData.push({ label: "navBanner", value: "navBanner" })
       }
        if(editData.popup){
          bannerTypeData.push({ label: "popUp", value: "popUp" })
       }
        if(editData.pageBanner){
          bannerTypeData.push({ label: "pageBanner", value: "pageBanner" })
       }

        if(editData.footerPopup){
          bannerTypeData.push({ label: "footerPopup", value: "footerPopup" })
       }

       if(editData.contactSideView){
        bannerTypeData.push({label:"contactSideView",value:"contactSideView"})
       }

        if(editData.contactMidView){
        bannerTypeData.push({label:"contactMidView",value:"contactMidView"})
       }


       if(editData.tagArray){
        // console.log("before modify",editData.tagArray)
          editData.tagArray.map((val:any)=>{
            tagArrrrrr.push({ label: val, value: val })
          })

          // console.log("after modify",tagArrrrrr)

          setAdditionalDropdown(tagArrrrrr)
       }
      setBannerType([...bannerTypeData]);
      setBannerContentTypeSelected({ label: editData.bannerContentType, value: editData.bannerContentType });
  
      if (editData.bannerContentType === "HTML") {
        setHtmlContent(editData.renderingContent || "");
      } else {
       setImageUrl(editData.renderingContent || null)
      }
  
      setBannerStatus({ label: editData.status, value: editData.status });
  
      setDay(
        editData.visibleByDays?.length
          ? editData.visibleByDays.map((d: any) => ({ label: d, value: d }))
          : [{ label: "All", value: "All" }]
      );

     if(mapObj){
      console.log("editPage",editData.page)
      setPage({ label: editData.page, value:editData.page})
     }
  
      setFrequency({ label: editData.frequency, value: editData.frequency });
  
      setAutoLogin({ label: String(editData.autoLogin), value: String(editData.autoLogin) });
  
      setLandingUrl(editData.landingPageUrl || "");
      setImpressionGA(editData.impressionGA || "");
      setCtaGA(editData.ctaGA || "");
      setName(editData.name || "")
  
      if (editData.visibleStartDate && startdateRef.current) {
        const [day, month, year] = editData.visibleStartDate.split('/');
        const isoDate = `${year}-${month}-${day}`; 
        const startDate = new Date(isoDate);
        // console.log("modifiedDate", startDate);
      
        startdateRef.current.value = isoDate;
      }

      if (editData.visibleEndDate && endDateRaf.current) {
        const [day, month, year] = editData.visibleEndDate.split('/');
        const isoDate = `${year}-${month}-${day}`; 
        const startDate = new Date(isoDate);
        // console.log("modifiedDate", startDate);
      
        endDateRaf.current.value = isoDate;
      }
      
    }
  }, [isEdit, editData,mapObj]);


  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
     console.log("enterPage",page.value)

      if (!name) {
      alert("please enter the name");
      return;
    }

    if (!page?.value?.trim()) {
  alert("Please select the page.");
  return;
}
    if (bannerContentTypeSelected.value === "image" && !imageFile && !isEdit) {
      alert("Please upload an image.");
      return;
    }

   if (bannerContentTypeSelected.value === "image" && isEdit &&  !imageFile && !imageUrl) {
      alert("Please upload an image.");
      return;
    }
  
    if (bannerContentTypeSelected.value === "HTML" && htmlContent.trim() === "") {
      alert("Please enter HTML content.");
      return;
    }

      if (!landingUrl) {
      alert("please enter landing Url");
      return;
    }

    if (!landingUrl.startsWith("https://") && autoLogin.value=="false") {
      alert("Landing URL must start with https://");
      return;
    }

    if (!impressionGA) {
      alert("please enter Impression GA");
      return;
    }

    if (!ctaGA){
      alert("please enter Cta GA");
      return;
    }

    if(!startdateRef.current.value){
      alert("please enter start Date and end date both");
      return;
    }

     if(!endDateRaf.current.value){
      alert("please enter start Date and end date both");
      return;
    }

   
  
    try {
      let content = htmlContent;
  
     try {
  if (bannerContentTypeSelected.value === "image" && imageFile) {
    const s3Url = await uploadFileToS3(imageFile, user.uid); 
    content = s3Url;
  } else if (bannerContentTypeSelected.value === "image" && imageUrl) {
    content = imageUrl;
  }
} catch (error) {
   dispatcher(showSnackbarAction("invalid image file extension", "error"));
  return; // Optionally stop further execution if needed
}
          // console.log("dayyyy",day)
      const filterDay= day.map((val:any)=>val.value)
      const bannerT=bannerType.map((val:any)=>val.value)
      let tagArr:any=[];
      if(additionalDropdown && additionalDropdown.length >0){
       tagArr=additionalDropdown.map((val:any)=>val.value)
      }
  
      const data:any = {
        bannerType:bannerT,
        bannerContentType: bannerContentTypeSelected.value,
        renderingContent:content,
        status:bannerStatus.value,
        visibleStartDate:startdateRef.current.value?moment(startdateRef.current.value).toDate():null,
        visibleEndDate:endDateRaf.current.value?moment(endDateRaf.current.value).toDate():null,
        visibleByDays:filterDay,
        frequency:frequency.value,
        autoLogin:autoLogin.value=="true"?true:false,
        landingPageUrl:landingUrl?landingUrl:"",
        impressionGA:impressionGA?impressionGA:"",
        ctaGA:ctaGA?ctaGA:"",
        page:mapObj[page.value],
        name:name,
        tagArray:tagArr || []

      };

      console.log("banner creation data",data)

      if(isEdit){
        data["Id"]=editData._id

        await updateBanner(data,history,dispatcher)
      }else{
        await createBanner(data,history,dispatcher);
      }
  
      // Call your backend API here to save `data` into DB
      console.log("Final Data to Save:", data);
      // await axios.post("/api/save-banner", data);
  
      dispatcher(showSnackbarAction("Banner saved successfully!", "success"));
    } catch (err) {
      console.error("Error while submitting banner:", err);
      dispatcher(showSnackbarAction("Failed to save banner", "error"));
    }
  };
  const [startDate, setStartDate] = useState("");
  // console.log("start date and end date", startdateRef,endDateRaf);
 const handleStartDateChange = (e:any) => {
  const value = e.target.value;
  setStartDate(value);

  if (endDateRaf.current) {
    endDateRaf.current.min = value;
  }
};
  

useEffect(()=>{

  if(page.value && tagArr && Object.keys(tagArr).length >0){
        setTagOption( tagArr[mapObj[page.value]])
  }
},[page,tagArr])

console.log("safdgf",additionalDropdown)

  return (
    <div className={styles.parent} style={containerStyles}>
      <div className="d-flex flex-row w-100 px-4 pt-4">
        <h5>{isEdit?"Edit Banner Details":"Add Banner Details"}</h5>
        <AiOutlineClose
          className={styles.closeIcon}
          size={25}
          onClick={() => history.replace("/banerManagement")}
        />
      </div>

      <div className="w-100 d-flex flex-column gap-2 px-4">
        <form className="card p-4 shadow rounded mt-2" style={cardContainerStyles} onSubmit={handleSubmit}>
          <div className={styles.box2}>
            <div className={styles.divide}>
              <Label label="Banner Name" required={true} />
              <input
                className={styles.inputContainer}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className={styles.divide}>
              <Label label="Banner Type" required={true} />
              <div style={selectInputContainerStyles}>
                <Dropdown option={Requirement} selectedValue={bannerType} setSelectedValue={setBannerType} isMulti={true} />
              </div>
            </div>

            <div className={styles.divide}>
              <Label label="Banner Content Type" required={true} />
              <div style={selectInputContainerStyles}>
                <Dropdown
                  option={bannerContentType}
                  selectedValue={bannerContentTypeSelected}
                  setSelectedValue={setBannerContentTypeSelected}
                />
              </div>
            </div>

            {bannerContentTypeSelected.value === "image" && (
              <div className={styles.divide}>
                <Label label="Upload Image" required={true} />

                {imageUrl ? (
                  <div style={{ position: 'relative', display: 'inline-block', marginTop: '10px' }}>
                    <img src={imageUrl} alt="Uploaded" style={{ width: '200px', height: 'auto', borderRadius: '8px' }} />
                    <button
                      type="button"
                      onClick={() => setImageUrl(null)} // Allow re-upload
                      style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        background: 'red',
                        color: 'white',
                        border: 'none',
                        borderRadius: '50%',
                        cursor: 'pointer',
                        width: '24px',
                        height: '24px'
                      }}
                    >
                      ×
                    </button>
                  </div>
                ) : (
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => setImageFile(e.target.files?.[0] || null)}
                  />
                )}
              </div>
            )}



            {bannerContentTypeSelected.value === "HTML" && (
              <div className={styles.divide}>
                <Label label="Enter HTML Content" required={true} />
                <textarea
                  className={styles.inputContainer}
                  rows={10}
                  value={htmlContent}
                  onChange={(e) => setHtmlContent(e.target.value)}
                />
              </div>
            )}
          </div>
          <div className={styles.box2}>
          <div className={styles.divide}>
              <Label label="Page" required={true} />
              <div style={selectInputContainerStyles}>
                <Dropdown
                  option={pageArr}
                  selectedValue={page}
                  setSelectedValue={setPage}
                />
              </div>
            </div>

               
               <div className={styles.divide}>
                          <Label label="Start Date" required={true} />
                          <div style={{ ...selectInputContainerStyles }}>
                        <input
                          type="date"
                          placeholder="Enter Date"
                          ref={startdateRef}
                          max={maxDate}
                          onChange={handleStartDateChange}
                          
                          // className={styles.dateInput}
                        />
                          </div>
                        </div>
                        <div className={styles.divide}>
                          <Label label="End Date" required={true} />
                          <div style={{ ...selectInputContainerStyles }}>
                        <input
                          type="date"
                          placeholder="Enter Date"
                          ref={endDateRaf}
                          onChange={handleStartDateChange}
                         
                          // className={styles.dateInput}
                        />
                          </div>
                        </div>       
          </div>
          <div className={styles.box2}>
            <div className={styles.divide}>
              <Label label="Day" required={false} />
              <div style={selectInputContainerStyles}>
                <Dropdown option={['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday',"All"]} selectedValue={day} setSelectedValue={setDay} isMulti={true} />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Frequency" required={false} />
              <div style={selectInputContainerStyles}>
                <Dropdown option={[1,2,3,4,"All"]} selectedValue={frequency} setSelectedValue={setFrequency}  />
              </div>
            </div> 

             <div className={styles.divide}>
              <Label label="AutoLogin Url" required={false} />
              <div style={selectInputContainerStyles}>
                <Dropdown option={["true","false"]} selectedValue={autoLogin} setSelectedValue={setAutoLogin} />
              </div>
            </div> 
                  
          </div>
          <div className={styles.box2}>
          <div className={styles.divide}>
                <Label label="Enter landing URL" required={true} />
                <textarea
                   rows={10}
                  className={styles.inputContainer}
                  value={landingUrl}
                  onChange={(e) => setLandingUrl(e.target.value)}
                />
              </div>
              
            <div className={styles.divide}>
              <Label label="ImpressionGA" required={true} />
              <textarea
                rows={10}
                className={styles.inputContainer}
                value={impressionGA}
                onChange={(e) => setImpressionGA(e.target.value)}
              />
            </div>

            <div className={styles.divide}>
              <Label label="CtaGA" required={true} />
              <textarea
                rows={10}
                className={styles.inputContainer}
                value={ctaGA}
                onChange={(e) => setCtaGA(e.target.value)}
              />
            </div>                  
          </div>
          <div className={styles.box2}>
          <div className={styles.divide}>
              <Label label="Banner Status" required={false} />
              <div style={selectInputContainerStyles}>
                <Dropdown option={["ACTIVE","DRAFT","PREVIEW"]} selectedValue={bannerStatus} setSelectedValue={setBannerStatus} />
              </div>
            </div> 

        {mapObj[page.value] && tagOption && (  <div className={styles.divide}>
      <Label label="tag Dropdown" required={true} />
      <div style={selectInputContainerStyles}>
        <Dropdown
          option={tagOption || []}
          selectedValue={additionalDropdown}
          setSelectedValue={setAdditionalDropdown}
          isMulti={true}
        />
      </div>
    </div>)}
                  
          </div>

          <button type="submit" style={{ backgroundColor: "#279f9f" }} className={styles.button}>
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.user.data,
  organizationUsers: state.organizationUsers.data,
  role: state.user.role,
  theme: state.theme.isLightMode,
  authToken: state.user.authToken,
  organizationData: state.organization.organizationData,
  constants: state.constants.data,
  organizationResources: state.organizationResources.data,
});

export default connect(mapStateToProps)(Addbanner);
